'use strict';

/**
 * Find words in a string
 * @param {string} string - string to find words
 */
module.exports = words;
function words(string) {
  var foundWords = string.replace(/[^a-zа-яё\-_ ]/gi, '').replace(/([A-Z]+)/g, '_$1').split(/[-|_| ]+/g);

  if (foundWords[0] === '') {
    return foundWords.slice(1);
  }
  return foundWords;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/_internal/_words/index.js
// module id = 533
// module chunks = 0